import { styled } from "@mui/material/styles";

// Components
import { Button } from "@mui/material";
import FilterIcon from "@mui/icons-material/Filter";

const styledName = "IconInput";

export const StyledWrapper = styled("div", { name: styledName })({
  "&": {
    width: "80px",
    height: "80px",
    borderRadius: "16px",
    margin: "10px auto",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease-in",
    overflow: "hidden",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
});

export const StyledImageIcon = styled(FilterIcon, { name: styledName })({
  "&": {
    margin: "auto",
  },
});

export const StyledIconButton = styled(Button, { name: styledName })({
  "&": {
    height: "100%",
    width: "100%",
  },
});
